import { gsap } from 'gsap';

export function fadeIn(targetEl) {
    return new Promise((resolve) => {
        // kill the tween before
        gsap.killTweensOf(targetEl)
        // force opacity to 0
        targetEl.style.opacity = 0
        targetEl.style.display = "block"
        // tween to opacity 1
        gsap.to(targetEl, {
            opacity: 1,
            onComplete: resolve
        })
    })
}

export function fadeOut(targetEl) {
    return new Promise((resolve) => {
        // kill the tween before
        gsap.killTweensOf(targetEl)
        // tween to opacity 0
        gsap.to(targetEl, {
            opacity: 0,
            onComplete: () => {
                targetEl.style.display = "none";
                resolve();
            }
        })
    });
}

export function adjustHeight(targetEl, height) {
    return new Promise((resolve) => {
        gsap.killTweensOf(targetEl)
        gsap.to(targetEl, {
            height: height,
            onComplete: resolve
        })
    })
}
